import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  ILabel,
  ILabelDetailed,
  LabelProcessingTypeEnum,
} from 'Modules/Communication/shared/models/Labels'

const emailLabelsSlice = createSlice({
  name: 'emailLabels',
  initialState: {
    data: [] as ILabel[],
    error: null,
    loading: false,
    processing: null as LabelProcessingTypeEnum | null,
    processingError: null,
    details: null as ILabelDetailed | null,
  },
  reducers: {
    fetchRequest: (state) => {
      state.data = []
      state.loading = true
      state.error = null
    },
    fetchSuccess: (state, action: PayloadAction<ILabel[]>) => {
      state.data = action.payload
      state.loading = false
      state.error = null
    },
    fetchError: (state, action) => {
      state.loading = false
      state.error = action.payload
      state.data = []
    },

    fetchDetailsRequest: (state, _: PayloadAction<string>) => {
      state.details = null
    },
    fetchDetailsSuccess: (state, action: PayloadAction<ILabelDetailed>) => {
      state.details = action.payload
    },

    updateRequested: (
      state,
      action: PayloadAction<{
        id: string
        path?: string
        type: LabelProcessingTypeEnum
      }>
    ) => {
      state.processing = action.payload.type
      state.processingError = null
    },
    updateSuccess: (state) => {
      state.processing = null
      state.processingError = null
    },
    updateError: (state, action) => {
      state.processing = null
      state.processingError = action.payload
    },

    createRequested: (
      state,
      _: PayloadAction<{ path: string; isEmail?: boolean }>
    ) => {
      state.processing = LabelProcessingTypeEnum.create
      state.processingError = null
    },
    createSuccess: (state) => {
      state.processing = null
      state.processingError = null
    },
    createError: (state, action) => {
      state.processing = null
      state.processingError = action.payload
    },
  },
})

export default emailLabelsSlice
